import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";

import { LanguageContext } from "../i18n/LanguageProvider"
import { getMatchByJobId } from "../services/jobs";

// Hooks
export const useFetchMatchByJobId = ({ jobId, enabled }) => {
  const { language } = useContext(LanguageContext);

  return useQuery({
    queryKey: ["match", jobId, language],
    queryFn: () => getMatchByJobId(jobId),
    retry: false,
    staleTime: 3_600_000, // 1 hour
    enabled
  });
};
